var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8152 3.99185C11.7504 3.16612 10.2495 3.16612 9.18475 3.99185L4.4914 7.63143C3.78398 8.18002 3.37328 9.01661 3.37328 9.89963V15.7384C3.37328 17.3259 4.67932 18.6259 6.30662 18.6259H7.47995V14.5192C7.47995 12.5752 9.05591 10.9992 11 10.9992C12.944 10.9992 14.52 12.5752 14.52 14.5192V18.6259H15.6933C17.3206 18.6259 18.6266 17.3259 18.6266 15.7384V9.89963C18.6266 9.01661 18.2159 8.18002 17.5085 7.63143L12.8152 3.99185ZM8.4657 3.06465C9.95369 1.91074 12.0462 1.91074 13.5342 3.06465L18.2275 6.70423C19.2188 7.47294 19.7999 8.65047 19.7999 9.89963V15.7384C19.7999 17.9884 17.9541 19.7992 15.6933 19.7992H13.9333C13.6093 19.7992 13.3466 19.5366 13.3466 19.2126V14.5192C13.3466 13.2232 12.296 12.1726 11 12.1726C9.70392 12.1726 8.65328 13.2232 8.65328 14.5192V19.2126C8.65328 19.5366 8.39063 19.7992 8.06662 19.7992H6.30662C4.04584 19.7992 2.19995 17.9884 2.19995 15.7384V9.89963C2.19995 8.65047 2.78111 7.47294 3.77237 6.70423L8.4657 3.06465Z",
    fill: "#303030",
    stroke: "#303030",
    strokeWidth: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.9387fc751fd3752dbba5548fc7896596.svg";
export { ForwardRef as ReactComponent };